import * as React from 'react';
import C from 'classnames';
export const TablePagination = ({ pageCount, tableState: { pageIndex, pageSize }, paginationRange, gotoPage, previousPage, canPreviousPage, nextPage, canNextPage }) => {
    const paginationNumbers = [];
    const range = (from, to, step = 1) => {
        let i = from;
        const createRange = [];
        while (i <= to) {
            createRange.push(i);
            i += step;
        }
        return createRange;
    };
    if (pageCount > 1) {
        const startPage = Math.max(2, pageIndex - paginationRange);
        const endPage = Math.min(pageCount - 1, pageIndex + paginationRange);
        const pageRange = range(startPage, endPage);
        //console.log(startPage, endPage);
        for (let i = 1; i <= pageCount; i++) {
            if (i === pageCount && endPage !== pageCount - 1) {
                paginationNumbers.push(React.createElement("li", { className: C('page-item'), key: 'unk' + i },
                    React.createElement("button", { className: "page-link" }, "...")));
            }
            if (i === 1 || i === pageCount || pageRange.includes(i)) {
                paginationNumbers.push(React.createElement("li", { className: C('page-item', pageIndex + 1 === i ? 'active' : ''), key: 'page' + i },
                    React.createElement("button", { className: "page-link", onClick: () => {
                            gotoPage(i - 1);
                        } }, i)));
                if (i === 1 && startPage > 2) {
                    paginationNumbers.push(React.createElement("li", { className: C('page-item'), key: 'unk' + i },
                        React.createElement("button", { className: "page-link" }, "...")));
                }
            }
        }
    }
    return pageCount > 1 ? (React.createElement("nav", null,
        React.createElement("ul", { className: "pagination" },
            React.createElement("li", { className: "page-item" },
                React.createElement("button", { className: "page-link", onClick: () => previousPage(), disabled: !canPreviousPage }, "Previous")),
            paginationNumbers,
            React.createElement("li", { className: "page-item" },
                React.createElement("button", { className: "page-link", onClick: () => nextPage(), disabled: !canNextPage }, "Next"))))) : null;
};
export default TablePagination;
//# sourceMappingURL=TablePagination.js.map